// extracted by mini-css-extract-plugin
module.exports = {"link":"_1n6TA","timeAgo":"_3GzJy","avatar":"_2JPMk"};